import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import useWindowSize from "helpers/hooks/useWindowSize";
import { Media } from "solar/components/Media";
import Title from "components/adventure/Title";
import Text from "components/adventure/Text";
import PhotoCloudfront from "components/shared/adventures/PhotoCloudfront";
import VideoAutoPlay from "components/shared/adventures/VideoAutoPlay";
import styles from "components/adventure/Why.module.scss";

export default function Why({
  videoLandFirstFrameSrc,
  videoLandMp4 = null,
  videoLandWebm = null,
  title,
  description,
  images,
}) {
  const windowSize = useWindowSize();
  const breakpointLg = parseInt(styles.solBreakpointLg, 10);
  const [greaterThanLg, setGreaterThanLg] = useState(false);

  useEffect(() => {
    setGreaterThanLg(windowSize.width > breakpointLg);
  }, [windowSize, breakpointLg]);

  return (
    <div className={styles.component}>
      {videoLandMp4 && videoLandFirstFrameSrc && (
        <div className={styles.video}>
          <VideoAutoPlay
            videoLandFirstFrameSrc={videoLandFirstFrameSrc}
            videoLandMp4={videoLandMp4}
            videoLandWebm={videoLandWebm}
            videoAltText={title}
          />
        </div>
      )}

      {!videoLandMp4 && !videoLandMp4 && images && images.length >= 3 && (
        <div className={styles.gridContainer}>
          <div className={styles.gridOuter}>
            <div className={styles.gridItem}>
              <PhotoCloudfront
                src={images[0].file.url}
                sizes={[["lg", "100vw"], ["65vw"]]}
                width={images[0].file.width}
                height={images[0].file.height}
                className={styles.photo}
              />
            </div>
            <div className={styles.gridInner}>
              <div className={styles.gridItem}>
                <PhotoCloudfront
                  src={images[1].file.url}
                  sizes={[["lg", "50vw"], ["32vw"]]}
                  width={images[1].file.width}
                  height={images[1].file.height}
                  className={styles.photo}
                />
              </div>
              <div className={styles.gridItem}>
                <PhotoCloudfront
                  src={images[2].file.url}
                  sizes={[["lg", "50vw"], ["32vw"]]}
                  width={images[2].file.width}
                  height={images[2].file.height}
                  className={styles.photo}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className={styles.text}>
        <Media lessThan="lg">
          <Title className={styles.title}>{title}</Title>
        </Media>
        <Media greaterThan="md">
          <Title size="lg" className={styles.title}>
            {title}
          </Title>
        </Media>
        <Text
          maxLength={greaterThanLg ? null : 350}
          className={styles.description}
        >
          {description}
        </Text>
      </div>
    </div>
  );
}

Why.propTypes = {
  videoLandFirstFrameSrc: PropTypes.string,
  videoLandMp4: PropTypes.string,
  videoLandWebm: PropTypes.string,
  title: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      position: PropTypes.number,
      created_at: PropTypes.string,
      file: PropTypes.shape({
        byte_size: PropTypes.number,
        content_type: PropTypes.string,
        height: PropTypes.number,
        url: PropTypes.string,
        width: PropTypes.number,
      }),
    })
  ),
};
